export const STATUS_RED = 'red';
export const STATUS_GREEN = 'green';
export const STATUS_AMBER = 'amber';

export const SPECIES_CATTLE = 'cattle';
export const SPECIES_BEEF = 'beef';
export const SPECIES_SHEEP = 'sheep';
export const SPECIES_DEER = 'deer';